import { render, staticRenderFns } from "./STableDetailSaleComp.vue?vue&type=template&id=7f3d90e9&"
import script from "./STableDetailSaleComp.vue?vue&type=script&lang=js&"
export * from "./STableDetailSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports